import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Inventory from "@/pages/Inventory";
import Transactions from "@/pages/Transactions";
import Categories from "@/pages/Categories";
import Vault from "@/pages/Vault";
import Rentals from "@/pages/Rentals";
import Persons from "@/pages/Persons";
import Organizations from "@/pages/Organizations";
import PublicStock from "@/pages/PublicStock";
import PublicPersons from "@/pages/PublicPersons";
import PublicProduction from "@/pages/PublicProduction";

function Protected({ children }) {
    const { token, checking } = useAuth();
    if (checking) {
        return (
            <div className="min-h-screen flex items-center justify-center text-slate-500">
                Chargement…
            </div>
        );
    }
    if (!token) return <Navigate to="/" replace />;
    return children;
}

function PublicOnly({ children }) {
    const { token, checking } = useAuth();
    if (checking) return null;
    if (token) return <Navigate to="/dashboard" replace />;
    return children;
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Toaster position="top-right" richColors />
                    <Routes>
                        <Route path="/" element={<PublicStock />} />
                        <Route path="/production" element={<PublicProduction />} />
                        <Route path="/personnes" element={<PublicPersons />} />
                        <Route
                            path="/login"
                            element={
                                <PublicOnly>
                                    <Login />
                                </PublicOnly>
                            }
                        />
                        <Route
                            element={
                                <Protected>
                                    <Layout />
                                </Protected>
                            }
                        >
                            <Route path="/dashboard" element={<Dashboard />} />
                            <Route path="/inventory" element={<Inventory />} />
                            <Route path="/transactions" element={<Transactions />} />
                            <Route path="/categories" element={<Categories />} />
                            <Route path="/vault" element={<Vault />} />
                            <Route path="/rentals" element={<Rentals />} />
                            <Route path="/persons" element={<Persons />} />
                            <Route path="/organizations" element={<Organizations />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
